'use strict';
import * as $j_com$002eraquo$002eairstream$002eownership$002e$002dDynamic$002dSubscription$0024 from "./com.raquo.airstream.ownership.-Dynamic-Subscription$.js";
import * as $j_com$002eraquo$002elaminar$002emodifiers$002e$002dBinder$0024 from "./com.raquo.laminar.modifiers.-Binder$.js";
import * as $j_com$002eraquo$002elaminar$002emodifiers$002e$002dBinder$0024$0024anon$00241 from "./com.raquo.laminar.modifiers.-Binder$$anon$1.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1 from "./scala.scalajs.runtime.-Anon-Function1.$$-Lambda$412915ce24663401f4bc24349a746e1dbd693dc1.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_laminar_api_Implicits$RichSource$() {
}
export { $c_Lcom_raquo_laminar_api_Implicits$RichSource$ as $c_Lcom_raquo_laminar_api_Implicits$RichSource$ };
$p = $c_Lcom_raquo_laminar_api_Implicits$RichSource$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_laminar_api_Implicits$RichSource$;
/** @constructor */
function $h_Lcom_raquo_laminar_api_Implicits$RichSource$() {
}
export { $h_Lcom_raquo_laminar_api_Implicits$RichSource$ as $h_Lcom_raquo_laminar_api_Implicits$RichSource$ };
$h_Lcom_raquo_laminar_api_Implicits$RichSource$.prototype = $p;
$p.NJ = (function(this$, sink) {
  return new $j_com$002eraquo$002elaminar$002emodifiers$002e$002dBinder$0024$0024anon$00241.$c_Lcom_raquo_laminar_modifiers_Binder$$anon$1(new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$10) => {
    var observable = this$.dS();
    return $j_com$002eraquo$002eairstream$002eownership$002e$002dDynamic$002dSubscription$0024.$m_Lcom_raquo_airstream_ownership_DynamicSubscription$().XS(_$10.fs, observable, sink);
  })), $j_com$002eraquo$002elaminar$002emodifiers$002e$002dBinder$0024.$m_Lcom_raquo_laminar_modifiers_Binder$());
});
var $d_Lcom_raquo_laminar_api_Implicits$RichSource$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_laminar_api_Implicits$RichSource$, "com.raquo.laminar.api.Implicits$RichSource$", ({
  hy: 1
}));
export { $d_Lcom_raquo_laminar_api_Implicits$RichSource$ as $d_Lcom_raquo_laminar_api_Implicits$RichSource$ };
var $n_Lcom_raquo_laminar_api_Implicits$RichSource$;
function $m_Lcom_raquo_laminar_api_Implicits$RichSource$() {
  if ((!$n_Lcom_raquo_laminar_api_Implicits$RichSource$)) {
    $n_Lcom_raquo_laminar_api_Implicits$RichSource$ = new $c_Lcom_raquo_laminar_api_Implicits$RichSource$();
  }
  return $n_Lcom_raquo_laminar_api_Implicits$RichSource$;
}
export { $m_Lcom_raquo_laminar_api_Implicits$RichSource$ as $m_Lcom_raquo_laminar_api_Implicits$RichSource$ };
